var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("table", { staticClass: "table mt-0 table-sm table-hover" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "tbody",
        [
          _vm._l(_vm.recordsToEdit, function (r, index) {
            return _c("tr", { key: r.id }, [
              _c("td", [_vm._v(_vm._s(index + 1))]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("DetailCommentBlock", {
                    attrs: { invoice: _vm.invoice, detail: r },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "td",
                [
                  r?.drug?.id
                    ? [
                        _c("div", { staticClass: "input-group" }, [
                          _c("input", {
                            staticClass: "form-control",
                            attrs: { disabled: "", type: "text" },
                            domProps: { value: r?.drug?.title },
                          }),
                        ]),
                      ]
                    : [
                        _c("DrugSearchNew", {
                          ref: `search_drug_${index}`,
                          refInFor: true,
                          attrs: {
                            selectedDrug: r.drug,
                            searchOptions: {
                              currencyId: _vm.invoice.currency_id,
                            },
                          },
                        }),
                      ],
                  _vm._v(" "),
                  r.files.length
                    ? _c(
                        "div",
                        [
                          _c("PreviewPage", {
                            attrs: { files: r.files, hidePreview: true },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c("td", [
                _c("input", {
                  staticClass: "form-control",
                  attrs: { disabled: "", type: "text" },
                  domProps: { value: r.qty },
                }),
              ]),
              _vm._v(" "),
              _c("td", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: r.income_qty,
                      expression: "r.income_qty",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "number" },
                  domProps: { value: r.income_qty },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(r, "income_qty", $event.target.value)
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("DrugTraceTooltip", {
                    attrs: {
                      records: _vm.invoice.trace.filter(
                        (t) => t.object === "drug" && t.object_id === r.drug_id
                      ),
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("td", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: r.income_price,
                      expression: "r.income_price",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: r.income_price },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(r, "income_price", $event.target.value)
                    },
                  },
                }),
              ]),
            ])
          }),
          _vm._v(" "),
          _vm.passRecords.length
            ? _c("tr", { staticClass: "bg_success" }, [
                _c("td", { attrs: { colspan: "10" } }, [
                  _vm._v("Препараты без изменений количества"),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.passRecords, function (r, index) {
            return _c("tr", { key: r.id }, [
              _c("td", [_vm._v(_vm._s(index + 1))]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("DetailCommentBlock", {
                    attrs: { invoice: _vm.invoice, detail: r },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("td", [
                _c("input", {
                  staticClass: "form-control",
                  attrs: { disabled: "", type: "text" },
                  domProps: { value: r?.drug?.title },
                }),
              ]),
              _vm._v(" "),
              _c("td", [
                _c("input", {
                  staticClass: "form-control",
                  attrs: { disabled: "", type: "text" },
                  domProps: { value: r.income_qty },
                }),
              ]),
              _vm._v(" "),
              _c("td", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: r.qty,
                      expression: "r.qty",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "number" },
                  domProps: { value: r.qty },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(r, "qty", $event.target.value)
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("td", { attrs: { colspan: "5" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: r.income_price,
                      expression: "r.income_price",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: r.income_price },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(r, "income_price", $event.target.value)
                    },
                  },
                }),
              ]),
            ])
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { width: "40px" } }),
        _vm._v(" "),
        _c("th", { staticClass: "small_th" }),
        _vm._v(" "),
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", { staticClass: "medium_th" }, [_vm._v("ожидаемое")]),
        _vm._v(" "),
        _c("th", { staticClass: "medium_th" }, [_vm._v("фактическое")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "50px" } }),
        _vm._v(" "),
        _c("th", { staticClass: "medium_th" }, [_vm._v("стоимость")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }